module.exports = __webpack_public_path__ + "static/img/beans.9cb7ac6f.png";